import { render, staticRenderFns } from "./ExchangeOrder.vue?vue&type=template&id=168e2645&scoped=true&"
import script from "./ExchangeOrder.vue?vue&type=script&lang=js&"
export * from "./ExchangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeOrder.vue?vue&type=style&index=0&id=168e2645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e2645",
  null
  
)

export default component.exports